import { MVR_CONSTANTS } from 'wmic-pe-portals-utils-js';

function getMVRReportStatus(reportSource, orderedMVRStatus) {
    if (!reportSource || !orderedMVRStatus) {
        return '';
    }

    let reportStatus = MVR_CONSTANTS.MVR_ORDER_STATUSES.RECEIVED.KEY;

    if (reportSource === MVR_CONSTANTS.MVR_SOURCE.CGI) {
        if (MVR_CONSTANTS.MVR_ORDER_STATUSES.ORDERED.CODES.includes(orderedMVRStatus)) {
            reportStatus = MVR_CONSTANTS.MVR_ORDER_STATUSES.ORDERED.KEY;
        } else if (MVR_CONSTANTS.MVR_ORDER_STATUSES.ERROR.CODES.includes(orderedMVRStatus)) {
            reportStatus = MVR_CONSTANTS.MVR_ORDER_STATUSES.ERROR.KEY;
        } else if (MVR_CONSTANTS.MVR_ORDER_STATUSES.CANCELLED.CODES.includes(orderedMVRStatus)) {
            reportStatus = MVR_CONSTANTS.MVR_ORDER_STATUSES.CANCELLED.KEY;
        }
    }

    return reportStatus;
}

export default {
    getMVRReportStatus,
};
